(ns web3.screens.nameplate-locator
  (:require [web3.view :as v]
            [web3.i18n :as i]
            [web3.components.widgets :as widgets]
            [web3.routing.core :as routing]
            [cljs.core.async :refer [go chan put! close! <! >! timeout]]
            [web3.components.nameplate-locator :as locator]))

(v/defview locator
  {:header {:title (i/get :i/nameplate-locator)}}
  []
  [:div
   [locator/locator-contents]
   [widgets/black-button {:href (routing/drop-segments 1 :router/form-modal)
                          :class "flex margin-all-3"}
    (i/get :i/done)]])